import { render, staticRenderFns } from "./WikiPageTitleSearchModal.vue?vue&type=template&id=074e28d9"
import script from "./WikiPageTitleSearchModal.vue?vue&type=script&lang=ts"
export * from "./WikiPageTitleSearchModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports